var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8808 6.44601C15.9238 2.15798 12.9656 0 8.99999 0C5.03233 0 2.0762 2.15798 0.119206 6.44816C0.0407101 6.62105 0 6.80987 0 7.00107C0 7.19227 0.0407101 7.3811 0.119206 7.55399C2.0762 11.842 5.0344 14 8.99999 14C12.9677 14 15.9238 11.842 17.8808 7.55184C18.0397 7.20399 18.0397 6.80031 17.8808 6.44601ZM8.99999 12.454C5.67021 12.454 3.23223 10.6975 1.51264 7C3.23223 3.30245 5.67021 1.54601 8.99999 1.54601C12.3298 1.54601 14.7678 3.30245 16.4874 7C14.7698 10.6975 12.3318 12.454 8.99999 12.454ZM8.91742 3.22086C6.91088 3.22086 5.28418 4.91288 5.28418 7C5.28418 9.08712 6.91088 10.7791 8.91742 10.7791C10.924 10.7791 12.5507 9.08712 12.5507 7C12.5507 4.91288 10.924 3.22086 8.91742 3.22086ZM8.91742 9.40491C7.6396 9.40491 6.60536 8.32914 6.60536 7C6.60536 5.67086 7.6396 4.59509 8.91742 4.59509C10.1952 4.59509 11.2295 5.67086 11.2295 7C11.2295 8.32914 10.1952 9.40491 8.91742 9.40491Z",
    fill: "#7D828E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show_password_icon.e87e9bae0fa118b31f87cdd134e63ae6.svg";
export { ForwardRef as ReactComponent };